import { render, staticRenderFns } from "./sign-up-ref.vue?vue&type=template&id=4abac7ea&scoped=true&lang=pug&"
import script from "./sign-up-ref.vue?vue&type=script&lang=js&"
export * from "./sign-up-ref.vue?vue&type=script&lang=js&"
import style0 from "./sign-up-ref.vue?vue&type=style&index=0&id=4abac7ea&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abac7ea",
  null
  
)

export default component.exports